<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">              
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="searchText"
              hide-details
              @click:prepend="showFilter = !showFilter"
              @input="searchTerm"
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->             
              <router-link :to="{path: formPath}">
                  <v-btn color="success" icon dark>
                    <v-icon>add</v-icon>
                  </v-btn>  
              </router-link>                 
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text v-if="showFilter">
              <v-layout row wrap>
                <v-flex md2 xs6>
                  <v-menu                                 
                    ref="date_fr" lazy
                    v-bind:close-on-content-click="true"
                    transition="scale-transition"
                    offset-y full-width
                    v-bind:nudge-bottom="-22"                                                                  
                  >
                    <v-text-field box slot="activator" hide-details
                      label="Date From"
                      v-model="search.date_fr"
                      append-icon="event"
                      readonly clearable
                    ></v-text-field>
                    <v-date-picker v-model="search.date_fr" no-title scrollable></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md2 xs6>
                  <v-menu                                 
                    ref="date_to" lazy
                    v-bind:close-on-content-click="true"
                    transition="scale-transition"
                    offset-y full-width
                    v-bind:nudge-bottom="-22"                                                                 
                  >
                    <v-text-field box slot="activator" hide-details
                      label="Date To"
                      v-model="search.date_to"
                      append-icon="event"
                      readonly clearable
                    ></v-text-field>
                    <v-date-picker v-model="search.date_to" no-title scrollable></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md2 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_status"
                  :items="status"
                  item-value="id"
                  item-text="name"
                  label="Select Status"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                <v-flex md2 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_jalur"
                  :items="jalur"
                  item-value="id"
                  item-text="name"
                  label="Select Jalur"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                <v-flex md2 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_paym"
                  :items="types"
                  item-value="id"
                  item-text="name"
                  label="Select Payment"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                
                <v-flex md6 xs12>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 
                </v-flex>        
              </v-layout>  
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-0 tabular">
              <v-data-table                
                :headers="complex.headers"                
                :items="complex.items"
                :loading="complex.loading"
                :pagination.sync="complex.options"
                :rows-per-page-items="[{text:'All','value':-1}]"
                hide-actions
                >                
                <template slot="items" slot-scope="props">
                  <td>{{ ((complex.pagination.currentPage-1)*20)+(props.index+1) }}</td>                                                   
                  <td style="min-width:190px">{{ props.item.nama }} ({{props.item.gender === 1?'L':'P'}})</td>
                  <td>{{ props.item.telepon }}</td>                      
                  <td v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===props.item.jurusan_id) ? tingkats.find(x=>x.id===props.item.jurusan_id).description : tingkats.find(x=>x.id===props.item.tingkat_id).description}}</td>
                  <td>{{props.item.ayah_nama}}</td>
                  <td>{{props.item.ibu_nama}}</td>
                  <td>{{ props.item.lahir_tempat +', '+ $moment(props.item.lahir_tanggal).format('DD/MM/YYYY') }}</td>
                  <td v-if="status.length > 0">{{ status.find(x=>x.id===props.item.status) ? status.find(x=>x.id===props.item.status).name : null }}<br/>
                    <small>{{ Array.isArray(payments) && props.item.payment ?payments.find(x=>x.id===props.item.payment.reff_type) ? payments.find(x=>x.id===props.item.payment.reff_type).name : null :null}}</small>
                  </td>
                  <td>
                    <span v-if="props.item.jalur_id == 1">Reguler</span>
                    <span v-else-if="props.item.jalur_id == 2">Prestasi</span>
                    <span v-else-if="props.item.jalur_id == 3">Undangan</span>
                  </td>
                  <td>{{$moment(props.item.created_at*1000).format('DD-MMMYY (HH:mm)')}}</td>                    
                  <td>{{$moment(props.item.updated_at*1000).format('DD-MMMYY (HH:mm)')}}</td>                    
                  <td class="text-xs-left" style="min-width:140px">
                    <v-btn class="success--text" depressed icon small @click="dialog.status = true; dialog.nomor=props.item.whatsapp?props.item.whatsapp:props.item.telepon;">
                      <v-icon>whatshot</v-icon>
                    </v-btn>
                    </router-link>
                    <router-link :to="{path:viewPath, query: {id: props.item.user_id}}">
                      <v-btn depressed icon class="primary--text" small>
                        <v-icon>find_in_page</v-icon>
                      </v-btn>
                    </router-link>          
                    <router-link :to="{path:cardPath, query: {id: props.item.user_id}}" v-if="props.item.status >= 3 && props.item.tingkat_id != 1">
                      <v-btn depressed icon class="primary--text" small>
                        <v-icon>local_offer</v-icon>
                      </v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
              <v-divider/>
              <div class="text-xs-center pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                                     
        </v-layout>
      </v-container>
      <v-dialog v-model="dialog.status" scrollable max-width="300px">        
        <v-card>
          <v-card-title>Kirim Pesan Melalui WA</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-text-field v-model="dialog.nomor" type="tel" label="Nomor Hp"></v-text-field>
            <v-textarea v-model="dialog.text" label="pesan text"></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="dialog.status = false; dialog.nomor=''; dialog.text=''">Close</v-btn>
            <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+dialog.nomor+'&text='+dialog.text"><v-btn color="green darken-1" flat>Kirim</v-btn></a>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        dialog : {
          status : false,
          nomor  : '',
          text   : '',
        },
        formPath : '/calon/form',
        viewPath : '/calon/view',
        cardPath : '/calon/card',
        searchText   : '',  
        search:{date_fr :null, date_to:null},      
        loading  : true,
        toggle_tingkat : [],
        toggle_gender : [],
        toggle_status : [],
        toggle_jalur : [],
        toggle_paym : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },             
              { text: 'Nama', value: 'nama'},              
              { text: 'Telepon', value: 'telepon'},
              { text: 'Tingkat', value: 'tingkat_id'},              
              { text: 'Nama Ayah',   value: 'ayah_nama'  },
              { text: 'Nama Ibu',   value: 'ibu_nama'  },
              { text: 'Tempat/Tgl Lahir', value:'tempat_lahir'},
              { text: 'Status', value:'status'},
              { text: 'Jalur', value: 'jalur_id'},
              { text: 'Created', value:'created_at' },
              { text: 'Updated', value:'updated_at' },
              { text: 'Action', value: '', align:'center' },              
            ],
            items: [],
            options : {},
            loading : false,
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            },
            
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        jalur    : [{id:1,name:'Reguler'},{id:2,name:'Prestasi'},{id:3,name:'Undangan'}],
        showFilter : true,
        payments:[],
    }),  
    watch:{
      'dialog.nomor'(newNmr){        
        if(newNmr && newNmr.charAt(0) === '0'){
          this.dialog.nomor = '+62'+newNmr.slice(1); 
        }
      },
      toggle_tingkat(newArr){
        let tingkat = [], jurusan = [];
        newArr.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });                
        this.init(this.complex.pagination.currentPage, this.toggle_gender, tingkat, jurusan);        
      },
      toggle_gender(newArr){                
        this.init(this.complex.pagination.currentPage, newArr, this.filter.tingkat, this.filter.jurusan);        
      },
      toggle_jalur(newArr){                
        this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan);        
      },
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      }, 
      'search':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      },
      toggle_paym(){
        this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)        
      },
      toggle_status(){
        this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)        
      },
    },
    computed:{
      filter(){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        return {tingkat: tingkat, jurusan:jurusan};
      }
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});
      model.status().then(data=>{this.status = data});
      model.paymentTypes().then(data=>{this.types = data});
      model.settings({key:'payment_method'}).then(res=>{
        this.payments = res.value;
      });
      this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },
        
        searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)                         
        }, 500),

        init(page = 1, gender='', tingkat='', jurusan_id=''){
          this.complex.loading = true
          let  sortby = this.complex.options.sortBy ? this.complex.options.sortDesc ? 
            '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

          const params = {
            perPage: 20,
            page: page,
            expand:'payment',
            'UserCalonSearch[nama]': this.searchText,
            'UserCalonSearch[gender]': gender,
            'UserCalonSearch[tingkat_id]': tingkat,
            'UserCalonSearch[jurusan_id]': jurusan_id,
            'UserCalonSearch[status]': this.toggle_status,
            'UserCalonSearch[paym]': this.toggle_paym,
            'UserCalonSearch[date_fr]':this.search.date_fr,
            'UserCalonSearch[date_to]':this.search.date_to,
            'UserCalonSearch[jalur_id]':this.toggle_jalur,
            sort:sortby,              
          }
          this.complex.items = [];
          model.index(params).then(res => {      
              this.complex.items = res.data; 
              this.complex.pagination.pageCount = res.pagination.pageCount;  
              this.complex.loading = false;
          });                                         
        },                                                                            
    }
}
</script>
<style>
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 7px 0 15px
}
</style>